import { Box, Icon, IconSize, Text } from '@bechtel/gds';
import { map } from 'lodash';
import { FC } from 'react';
import { ErrorBoundary } from '~/components';
import {
  AdminListCollapsedStyled,
  ExpandCollapseBorderBoxStyled,
  ExpandCollapseBoxStyled,
  ListContainerStyled,
  MenuItemStyled,
  NavLinkStyled,
  ProjectAdminListContainerStyled,
} from './styled';
import { ProjectAdminListProps, ProjectAdminMenuItem } from './types';
import { ProjectAdminMenuItems } from './utils';

export const ProjectAdminList: FC<ProjectAdminListProps> = ({ isListCollapsed, onToggleCollapse }) => {
  const projectAdminMenuItems = ProjectAdminMenuItems();

  return (
    <ErrorBoundary>
      <ListContainerStyled isListCollapsed={isListCollapsed}>
        <ProjectAdminListContainerStyled isListCollapsed={isListCollapsed}>
          <Box
            px={{ sm: '500' }}
            py={{ sm: '600' }}
            css={`
              ${({ theme }) => `border-bottom: solid 1px ${theme.colors.grey[300]} `}
            `}
          >
            <Text family="openSans" style={{ lineHeight: '1.5' }} size="500" weight="600">
              Project Settings
            </Text>
          </Box>
          <Box flexDirection={{ sm: 'column' }} style={{ overflowY: 'auto' }}>
            {map(projectAdminMenuItems, (item: ProjectAdminMenuItem) => {
              return (
                <NavLinkStyled to={`/project-admin/${item.value}`} key={item.value}>
                  <MenuItemStyled>{item.label}</MenuItemStyled>
                </NavLinkStyled>
              );
            })}
          </Box>
        </ProjectAdminListContainerStyled>
        <AdminListCollapsedStyled isListCollapsed={isListCollapsed}></AdminListCollapsedStyled>
        <ExpandCollapseBorderBoxStyled isListCollapsed={isListCollapsed}>
          <ExpandCollapseBoxStyled onClick={onToggleCollapse}>
            <Icon
              icon={isListCollapsed ? 'chevron-right' : 'chevron-left'}
              size={IconSize.MEDIUM}
              fillColor="blue.800"
            />
          </ExpandCollapseBoxStyled>
        </ExpandCollapseBorderBoxStyled>
      </ListContainerStyled>
    </ErrorBoundary>
  );
};
